import axios from "axios";

const baseurl = process.env.REACT_APP_TICKETING_TOOL_BACKEND_URL;

/**
 * Get auth token
 * 
 *
*/

const handleLogout = () => {
  const currentUrl = window.location.origin; 
  // sessionStorage.clear();
  localStorage.clear();

  const redirectUrl = `${currentUrl}/login`;
  window.location.replace(redirectUrl);
};

const getToken = () => {
    return localStorage.getItem("token");
};

/**
 * GET request (params + headers)
*/
export async function fetchData(endpoint, params = {}) {
    try {
        const response = await axios.get(`${baseurl}${endpoint}`, {
            params,
            headers: {
                "x-api-key": getToken(),
            },
        });
        return response;
    } catch (error) {
        if(error.response.status===401){
          handleLogout()
        }
        throw error;
    }
}

/**
 * POST request (ONLY FormData + headers)
*/
export async function postData(endpoint, formData) {
    // const baseurl = process.env.TICKETING_TOOL_BACKEND_URL;
  try {
    const response = await axios.post(
      `${baseurl}${endpoint}`,
      formData,
      {
        headers: {
          "x-api-key": getToken(),
        },
      }
    );
    return response;
  } catch (error) {
    if(error.response.status===401){
          handleLogout()
        }
    throw error;
  }
}

/**
 * PUT request (FormData + params)
 */
export async function putData(endpoint, formData, params = {}) {
  try {
    const response = await axios.put(
      `${baseurl}${endpoint}`,
      formData,
      {
        params,
        headers: {
          "x-api-key": getToken(),
        },
      }
    );
    return response;
  } catch (error) {
    if(error.response.status===401){
          handleLogout()
        }
    throw error;
  }
}

// /**
//  * DELETE request (FormData + params)
//  */
// export async function deleteData(endpoint, formData, params = {}) {
//   try {
//     const response = await axios.delete(`${baseurl}${endpoint}`, {
//       data: formData,
//       params,
//       headers: {
//         "x-api-key": getToken(),
//       },
//     });
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }
